import { SHAPE_TYPES, PROJECT_TYPES } from './concreteEstimatorCalc';

export function findProductForGrade(productList, grade) {
    if (!grade || !productList?.length) return null;
    const token = String(grade).toUpperCase();
    const active = productList.filter((p) => p.status !== false);
    return active.find((p) => {
        const name = (p.name || p.product_name || '').toUpperCase();
        return name.includes(token) || name.replace(/\s/g, '').includes(token.replace(/\s/g, ''));
    }) || null;
}

export function buildQuotationPrefillFromEstimate(estimate, productList = []) {
    const lines = estimate.lines || [];
    const grades = [...new Set(lines.map((line) => line.concrete_grade).filter(Boolean))];
    const gradeSummary = grades.length === 1 ? grades[0] : grades.length > 1 ? 'Various' : (estimate.concrete_grade || 'M20');
    const projectTypeLabel = PROJECT_TYPES.find((p) => p.value === estimate.project_type)?.label
        || estimate.project_type;

    const estimateRef = `${estimate.prefix || ''}${estimate.estimate_no || ''}`.trim();
    const summaryRemark = [
        `Concrete estimate ref: ${estimateRef}`,
        `Project: ${estimate.project_name}`,
        `Type: ${projectTypeLabel}`,
        `Grade: ${gradeSummary}`,
        `Total volume: ${Number(estimate.total_volume_m3 || 0).toFixed(3)} m³`,
        estimate.user_remarks || '',
    ].filter(Boolean).join(' | ');

    const quotedRate = Number(estimate.quoted_rate_per_m3 || estimate.rate_working?.rate_per_m3 || 0);
    const taxId = estimate.rate_working?.tax_id ? String(estimate.rate_working.tax_id) : '';

    const rowsData = lines.length > 0
        ? lines.map((line, index) => {
            const shapeLabel = SHAPE_TYPES.find((s) => s.value === line.shape_type)?.label || line.shape_type;
            const qty = Number(line.volume_m3 || 0);
            const lineGrade = line.concrete_grade || estimate.concrete_grade || 'M20';
            const product = findProductForGrade(productList, lineGrade);
            const productId = product?.id ? String(product.id) : '';
            const unitSymbol = product?.unit?.symbol || product?.unit_id || 'm³';
            const rate = quotedRate > 0 ? quotedRate.toFixed(2) : '';
            const amount = quotedRate > 0 && qty > 0 ? (qty * quotedRate).toFixed(2) : '';
            return {
                soDSqlNo: index + 1,
                tax_id: taxId,
                concrete_structure_id: '',
                delivery_mode: 'manual/pump',
                unit_id: unitSymbol,
                quantity: qty > 0 ? qty.toFixed(3) : '',
                rate,
                amount,
                product_id: productId,
                user_remarks: [line.item_name, shapeLabel, lineGrade, line.user_remarks].filter(Boolean).join(' — '),
            };
        })
        : [{
            soDSqlNo: 1,
            tax_id: taxId,
            concrete_structure_id: '',
            delivery_mode: 'manual/pump',
            unit_id: findProductForGrade(productList, gradeSummary)?.unit?.symbol || 'm³',
            quantity: Number(estimate.total_volume_m3 || 0).toFixed(3),
            rate: quotedRate > 0 ? quotedRate.toFixed(2) : '',
            amount: quotedRate > 0 && Number(estimate.total_volume_m3 || 0) > 0
                ? (Number(estimate.total_volume_m3) * quotedRate).toFixed(2)
                : '',
            product_id: findProductForGrade(productList, gradeSummary)?.id
                ? String(findProductForGrade(productList, gradeSummary).id)
                : '',
            user_remarks: summaryRemark,
        }];

    const firstProduct = rowsData[0]?.product_id
        ? productList.find((p) => String(p.id) === rowsData[0].product_id)
        : findProductForGrade(productList, gradeSummary);

    return {
        fromConcreteEstimator: true,
        estimateId: estimate.id,
        estimateRef,
        inputs: {
            customer_id: estimate.customer_id ? String(estimate.customer_id) : '',
            consignee_id: estimate.consignee_id ? String(estimate.consignee_id) : '',
            enquiry_no: estimateRef,
            terms_condition: summaryRemark,
            kind_attention: '',
            user_remarks: estimate.user_remarks || '',
        },
        rowsData,
        customerLabel: estimate.customer_name || '',
        siteLabel: estimate.consignee_name || '',
        matchedProductId: firstProduct?.id,
        productCategoryIds: firstProduct?.category?.id
            ? [firstProduct.category.id]
            : [],
    };
}
